export default "__VITE_PUBLIC_ASSET__8938efb6__"